export default __webpack_public_path__ + "static/media/shared.d74bc2cc.svg";